import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureRunTaskListingRenderer from '../procedures/ProcedureRunTaskListingRenderer';

export default class RecipeRunTaskListingRenderer extends ProcedureRunTaskListingRenderer<ListingRendererType.RECIPE_RUN_TASK> {
  listingRendererType = ListingRendererType.RECIPE_RUN_TASK;

  constructor() {
    super(ProcessClientOrigin.RECIPES);
  }
}
